import {TrackMixAudioSync} from '@spout/any-shared/models';
import {hasValue, msToSec} from '@uiux/fn';

export function getSnippetStopTime(snippet: TrackMixAudioSync): number | string {
  return hasValue(snippet.stop)
    ? snippet.stop + msToSec(snippet.offsetMs)
    : <number>snippet.start + snippet.audioDuration + msToSec(snippet.offsetMs);
}
